import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetVendorById } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";

const ViewVendor = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();
  var param = useParams();
  const vendor_id = param.Vendor_id;
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    website: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    term: "Select Term",
    balance: "0",
    notes: "",
    r_street: "",
    r_city: "",
    r_state: "",
    r_zip: "",
    r_country: "",
    r_phone: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_name: "",
    s_phone: "",
  });

  // const ActsGrid = [
  //   {
  //     field: "note",
  //     headerText: "Ledger Note",
  //     minWidth: "360",
  //     width: "440",
  //     maxWidth: "650",
  //     textAlign: "left",
  //   },
  //   {
  //     field: "datetime",
  //     headerText: "DateTime",
  //     minWidth: "180",
  //     width: "180",
  //     maxWidth: "240",
  //     textAlign: "center",
  //   },
  //   {
  //     field: "credit",
  //     headerText: "Credit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "debit",
  //     headerText: "Debit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "bal",
  //     headerText: "Balance",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  // ];

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    navigate("/Vendor");
  };

  useEffect(() => {
    async function fetchData() {
      if (vendor_id) {
        TimeoutUtility.resetTimeout();
        await GetVendorById(vendor_id)
          .then((result) => {
            setFormData({
              name: result.data.name || "",
              phone: result.data.phone || "",
              website: result.data.website || "",
              contact_name: result.data.contact_name || "",
              contact_phone: result.data.contact_phone || "",
              contact_email: result.data.contact_email || "",
              term: result.data.term
                ? { label: result.data.term, value: result.data.term_id }
                : "Select Term",
              balance: result.data.balance || "0",
              notes: result.data.notes || "",
              r_street: result.data.r_street || "",
              r_city: result.data.r_city || "",
              r_state: result.data.r_state || "",
              r_zip: result.data.r_zip || "",
              r_country: result.data.r_country || "",
              r_phone: result.data.r_phone || "",
              s_street: result.data.s_street || "",
              s_city: result.data.s_city || "",
              s_state: result.data.s_state || "",
              s_zip: result.data.s_zip || "",
              s_country: result.data.s_country || "",
              s_name: result.data.s_attention_name || "",
              s_phone: result.data.s_phone || "",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [vendor_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW VENDOR" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} style={{ padding: "0" }}>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>GENERAL INFORMATION</b>
                </div>
                <TextInputField
                  label="Company Name:"
                  name="name"
                  value={formData.name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Phone:"
                  name="phone"
                  value={formData.phone}
                  placeholder="Phone"
                  disabled
                />
                <TextInputField
                  label="Website:"
                  name="website"
                  value={formData.website}
                  placeholder="Website"
                  disabled
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  placeholder="Opening Balance"
                  disabled
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>CONTACT INFORMATION</b>
                </div>
                <TextInputField
                  label="Contact Name:"
                  name="contact_name"
                  value={formData.contact_name}
                  placeholder="Contact Name"
                  disabled
                />
                <TextInputField
                  label="Contact Phone:"
                  name="contact_phone"
                  value={formData.contact_phone}
                  disabled
                  placeholder="Contact Phone"
                />
                <TextInputField
                  label="Contact Email:"
                  name="contact_email"
                  value={formData.contact_email}
                  disabled
                  placeholder="Contact Email"
                />
                <SelectField
                  label="Terms:"
                  name="term"
                  value={formData.term}
                  isDisabled
                  placeholder="Terms"
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  disabled
                  placeholder="Notes"
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>REMITTING ADDRESS</b>
                </div>
                <TextAreaField
                  label="Street:"
                  name="r_street"
                  value={formData.r_street}
                  disabled
                  placeholder="Street"
                />
                <TextInputField
                  label="City:"
                  name="r_city"
                  value={formData.r_city}
                  disabled
                  placeholder="City"
                />
                <TextInputField
                  label="Zip:"
                  name="r_zip"
                  value={formData.r_zip}
                  disabled
                  placeholder="Zip"
                />
                <TextInputField
                  label="State:"
                  name="r_state"
                  value={formData.r_state}
                  disabled
                  placeholder="State"
                />
                <TextInputField
                  label="Country:"
                  name="r_country"
                  value={formData.r_country}
                  disabled
                  placeholder="Country"
                />
                <TextInputField
                  label="Phone:"
                  name="r_phone"
                  value={formData.r_phone}
                  disabled
                  placeholder="Phone"
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>SHIPPING ADDRESS</b>
                </div>
                <TextAreaField
                  label="Street:"
                  name="s_street"
                  value={formData.s_street}
                  disabled
                  placeholder="Street"
                />
                <TextInputField
                  label="City:"
                  name="s_city"
                  value={formData.s_city}
                  disabled
                  placeholder="City"
                />
                <TextInputField
                  label="Zip:"
                  name="s_zip"
                  value={formData.s_zip}
                  disabled
                  placeholder="Zip"
                />
                <TextInputField
                  label="State:"
                  name="s_state"
                  value={formData.s_state}
                  disabled
                  placeholder="State"
                />
                <TextInputField
                  label="Country:"
                  name="s_country"
                  value={formData.s_country}
                  disabled
                  placeholder="Country"
                />
                <TextInputField
                  label="Attention Name:"
                  name="s_name"
                  value={formData.s_name}
                  disabled
                  placeholder="Attention Name"
                />
                <TextInputField
                  label="Phone:"
                  name="s_phone"
                  value={formData.s_phone}
                  disabled
                  placeholder="Phone"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewVendor;
